<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="活动"
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="105px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动名称" prop="ActivityName">
              {{ data.ActivityName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="isMB ? '' : '封面图片'"
              :label-width="isMB ? '0' : ''"
              prop="CoverPhoto"
            >
              <el-divider v-if="isMB">封面图片</el-divider>
              <single-pic-upload
                v-model="data.CoverPhoto"
                type="CoverPhoto"
                :uploadUrl="uploadUrl"
                IsDetail
              ></single-pic-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-divider>活动详情</el-divider>
            <div v-html="data.ActivityNotes"></div>
            <el-divider></el-divider>
          </el-col>
          <el-col :span="24">
            <el-form-item label="活动简介" prop="ActivityBrief">
              {{ data.ActivityBrief }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="活动地点" prop="ActivityAddress">
              {{ data.ActivityAddress }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="开始时间" prop="BeginTime">
              {{ $commonJs.toDatetimeString(data.BeginTime) }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="结束时间" prop="EndTime">
              {{ $commonJs.toDatetimeString(data.EndTime) }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="咨询电话" prop="SeekPhone">
              {{ data.SeekPhone }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="报名截止时间" prop="EnrollEndtime">
              {{ $commonJs.toDatetimeString(data.EnrollEndtime) }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="可报名总人数" prop="EnrollNumber">
              {{ data.EnrollNumber }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="发布日期" prop="ReleaseTime">
              {{ $commonJs.toDatetimeString(data.ReleaseTime) }}
            </el-form-item>
          </el-col>

          <!-- <el-col :span="24">
            <el-form-item label="序号" prop="OrderId">
              {{ data.OrderId }}
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 16" style="padding-left: 17px">
            <div style="margin-bottom: 6px">审核日志</div>
            <el-table :data="tableData" border size="small">
              <el-table-column prop="UserName" label="操作人" />
              <el-table-column prop="OperResult" label="操作结果">
                <template slot-scope="{ row }">
                  <span v-if="row.OperResult == 1">提交</span>
                  <span v-else-if="row.OperResult == 2">通过</span>
                  <span v-else-if="row.OperResult == 3">不通过</span>
                  <span v-else-if="row.OperResult == 4">撤销审核</span>
                </template>
              </el-table-column>
              <el-table-column prop="OperMsg" label="备注" />
              <el-table-column prop="OperTime" label="操作时间" />
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <template v-if="$permission.canReview()">
          <template v-if="data.State == 1">
            <el-button type="success" @click="pass">通 过</el-button>
            <el-button type="danger" @click="noPass">不通过</el-button>
          </template>
          <el-button type="warning" v-else-if="data.State == 2" @click="cancel"
            >撤销审核</el-button
          >
        </template>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },
  computed: {
    host() {
      return window.location.origin;
    },
  },
  data() {
    return {
      data: {
        RecordId: 0,
        ActivityName: "",
        ShowIndex: 0,
        ShowEnd: 0,
        CoverPhoto: "",
        ActivityNotes: "",
        ActivityBrief: "",
        BeginTime: null,
        EndTime: null,
        SeekPhone: "",
        EnrollMust: 1,
        EnrollEndtime: null,
        EnrollNumber: 1,
        ReleaseTime: null,
        OrderId: 0,
        State: 0,
        ActivityAddress: "",
      },
      fl: [],
      tableData: [],
      api: require("@/api/operate/activity").default,
      isMB: this.$store.state.isMB,
      rules: {},
      uploadUrl: "/api/Common/UploadPicture",
    };
  },
  methods: {
    onCreateOpened(data) {},
    onDetailsOpened(data) {
      this.loading(true);
      this.api.getChecklogs({ ActivityId: this.data.RecordId }).then((res) => {
        this.loading(false);
        if (res.Code == 0) this.tableData = res.Data;
      });
    },
    dlfile(file) {
      const elink = document.createElement("a");
      elink.download = file.name;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = this.host + file.url;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    pass() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.pass(this.data.RecordId).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    noPass() {
      this.$prompt("请输入不通过原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        inputPlaceholder: "请输入不通过原因",
      })
        .then(({ value }) => {
          this.loading(true);
          this.api
            .noPass({ Id: this.data.RecordId, CheckMsg: value })
            .then((res) => {
              this.loading(false);
              if (res.Code == 0) {
                this.$message.success(res.Msg);
                this.$emit("close-saved");
                this.close(true);
              } else {
                this.$message.error(res.Msg);
              }
            });
        })
        .catch(() => {});
    },
    cancel() {
      this.$confirm("确认撤销审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.cancelReview(this.data.RecordId).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    onBeforeSave() {
      return false;
    },
    onClosed() {
      this.tableData = [];
      this.fl = [];
    },
  },
};
</script>
<style lang="scss">
.file-text2 {
  .el-upload--text {
    display: none;
  }
  .el-upload-list__item-name {
    margin-top: -8px;
  }
}
</style>